import type { IProfileStore } from 'src/stores/JobApplicationStore/ProfileStore';
import type { TrackStatusUpdateAttributes } from './eventsTypes';

export const convertToIsVerifiedId = (
  profileStore: IProfileStore | null,
): TrackStatusUpdateAttributes['isVerifiedId'] =>
  profileStore?.verifiedIdentity?.fullName ? 1 : 0;
